import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useEffect } from "react";
import type { FileData } from "@/services/files";
import { t } from "i18next";
import { CustomCollapsibleItem } from "@/components/ui/custom-collapsible-item";
import { ParagraphSkeleton } from "@/components/ui/skeleton/ParagraphSkeleton";
import {
  FileLatestVersion,
  useFileVersionStore,
} from "@/store/fileVersion.store";
import { StatusFile } from "@/common/enums/enums";

interface Props {
  file: FileData;
  id: number;
  expanded: boolean;
  onToggle: () => void;
}

export const CardContentMainTranscription: React.FC<Props> = (props) => {
  const {
    fetch,
    fileVersion,
    loading,
    fileVersionId: selectedVersion,
    setFileVersionId: setFileVersionId,
    reset,
  } = useFileVersionStore();

  const transcription =
    selectedVersion === FileLatestVersion
      ? props.file.transcription
      : fileVersion?.transcription;

  useEffect(() => {
    if (selectedVersion !== FileLatestVersion) {
      void fetch(props.file.id, Number(selectedVersion));
    } else {
      reset();
    }
  }, [selectedVersion, fetch, props.file.id, reset]);

  return (
    <CustomCollapsibleItem
      expanded={props.expanded}
      id={props.id}
      title={<h3 className="text-lg font-bold">{t("visit.recording")} #1</h3>}
      content={
        <>
          {props.file.versions.length > 0 && (
            <div className="flex items-center">
              <div className="pb-4">
                <Select
                  disabled={loading}
                  value={selectedVersion}
                  onValueChange={setFileVersionId}
                >
                  <SelectTrigger className="h-8 px-2 text-sm">
                    <SelectValue
                      placeholder={t(
                        "visits.templateViewer.version.chooseVersion"
                      )}
                    />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem key={0} value={FileLatestVersion}>
                      {t("visits.templateViewer.version.latest")}
                    </SelectItem>
                    {props.file.versions.map((version) => (
                      <SelectItem
                        key={version.id}
                        value={version.id.toString()}
                      >
                        {t("visits.templateViewer.version.version")}{" "}
                        {version.version}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </div>
          )}
          {loading || props.file.status === StatusFile.PROCESSING.toString() ? (
            <ParagraphSkeleton lines={10} />
          ) : (
            <p>{transcription}</p>
          )}
        </>
      }
      onToggle={props.onToggle}
    />
  );
};
